import { ADD_KUOBZ, CLEAR_KUOBZES, INIT_KUOBZES, UPDATE_SINGLE_KUOBZ } from '../type';
import axiosInstance from '../../config/axios.config';
import { success } from './loader.action';

export const initKuobzes = (kuobzes) => ({
  type: INIT_KUOBZES,
  payload: kuobzes,
});

export const clearKuobzes = () => ({
  type: CLEAR_KUOBZES,
  payload: [],
});

export const updateSingle = (payload) => ({
  type: UPDATE_SINGLE_KUOBZ,
  payload: payload,
});

export const addKuobz = (kuobz) => ({
  type: ADD_KUOBZ,
  payload: kuobz,
});
// получение всех устройств
export const initKuobzesFromServer = (query) => async (dispatch, getState) => {
  try {
    // получение данных с сервера
    const result = await axiosInstance(`/api/devices/kuobz${query}`);

    if (result.data && result.status === 200) {
      dispatch(initKuobzes(result.data));
      return result; // Возвращаем данные для использования в .then()
    }
  } catch (error) {
    console.log(error);
  }
};

// добавление нового устройства
export const newKuobzFromServer = (payload) => async (dispatch) => {
  try {
    const response = await axiosInstance.post('/api/devices/kuobz', payload);
    if (response.status === 201) {
      // записываем в стейт сообщение об успешном выполнении
      dispatch(success());

      dispatch(addKuobz(response.data));
    }
  } catch (error) {
    console.log(error);
  }
};

// изменение устройства
export const editKuobzFromServer = (payload, kuobzId) => async (dispatch) => {
  try {
    const response = await axiosInstance.patch(`/api/devices/kuobz/${kuobzId}`, payload);
    if (response.status === 200) {
      // записываем в стейт сообщение об успешном выполнении
      dispatch(success());
      dispatch(updateSingle({kuobzId, data: payload}));
    }
  } catch (error) {
    console.log(error);
  }
};

